 <template>
    <div >
        <multiselect
        class=""
        v-model="selected"
        placeholder="All"
        :options="sortedOptions"
        :multiple="true"
        track-by="name"
        :disabled="isDisabled"
        :custom-label="customLabel"
        >
        </multiselect>

        <input v-for="(option,key) in selectedOptions" :key="key" type="hidden" :name="isCategory ? option.query_name : fieldName" :value="option.id">
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
    name:'selectmultiple',
    components: { Multiselect },
    props: {
        fieldName: {
            type: String
        },
        options:{
            type: String,
        },
        isCategory: {
            type: Boolean,
            default: false
        },

    },
    data: function() {
        return{
            selected : []
        }
    },
    computed: {
        selectedOptions: function () {
            let selectedOptions = [];
            this.selected.forEach((item) => {
                selectedOptions.push(item);
            });
            return selectedOptions;
        },

        sortedOptions: function () {
            var unsortedOptions = JSON.parse(this.options);

            return unsortedOptions;
        },

        isDisabled : function() {
            return this.disabled == 'true';
        }
    },
    methods: {
        customLabel ({ name}) {
            return `${name}`
        }
    },
    mounted: function () {
        console.log("start");
        if(this.isCategory) {
            
                const urlParams = new URLSearchParams(window.location.search);
                var myCategories = [];
                var myMediums = [];

                for(var pair of urlParams.entries()) {
                    if (pair[0].includes('categories')) {
                        myCategories[myCategories.length] = pair[1]
                    }
                    if (pair[0].includes('mediums')) {
                        myMediums[myMediums.length] = pair[1]
                    }
                }

                var selected = []
                var options = JSON.parse(this.options);
                if(myCategories){
                    for (var key=0; key < myCategories.length; key++){
                        for (var i=0; i < options.length; i++) {
                            if (options[i].query_name == 'categories[]' && options[i].id == myCategories[key]) {
                                selected.push(options[i]);
                            }
                        }
                    };

                }
                if(myMediums){
                    for (var key=0; key < myMediums.length; key++){
                        for (var i=0; i < options.length; i++) {
                            if (options[i].query_name == 'mediums[]' && options[i].id == myMediums[key]) {
                                selected.push(options[i]);
                            }
                        }
                    };
                }

                this.selected = selected;
        }
        else {

            const urlParams = new URLSearchParams(window.location.search);
            var myParam = [];
            for(var pair of urlParams.entries()) {
                if (pair[0].includes(this.fieldName)) {
                    myParam[myParam.length] = pair[1]
                }
            }

            if(myParam){
                var selected = []
                var options = JSON.parse(this.options);
                for (var key=0; key < myParam.length; key++){
                    for (var i=0; i < options.length; i++) {
                        if (options[i].id == myParam[key]) {
                            selected.push(options[i]);
                        }
                    }
                };
                this.selected = selected;
            }
        }
        console.log("end");
    }

}
</script>